import React from 'react';
import * as IoC from 'typescript-ioc';
import { IOeDataOrganizationDTO } from '../../../../api/oe-data-organizations.dao';
import Text from '../../../global/text/text';
import { DateTimeFormatter } from '../../../../infrastructure/implementations/date-formatter';
import { TOeDataOrganizationColumnId } from '../oe-data-organization-columns';

interface IOeDataOrganizationsListItemProps {
    organization: IOeDataOrganizationDTO;
    visibleColumnIds: TOeDataOrganizationColumnId[];
}

const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);

const formatDate = (date: string): string => date ? dateTimeFormatter.dateToLocalString(new Date(date), 'UTC') : '';

const OeDataOrganizationsListItem = (props: IOeDataOrganizationsListItemProps) => {
    const { organization, visibleColumnIds } = props;

    const {
        name,
        shortName,
        organizationType,
        parentOrganizationName,
        hqCity,
        hqCountry,
        website,
        notes,
        createdAt,
        updatedAt,
        activeStatus,
        corporate,
    } = organization;

    const columnValues: Record<TOeDataOrganizationColumnId, string> = {
        name: name,
        shortName: shortName,
        organizationType: organizationType,
        parentOrganization: parentOrganizationName,
        hq: [hqCity, hqCountry].filter(Boolean).join(', '),
        hqCity: hqCity,
        hqCountry: hqCountry,
        website: website,
        notes: notes,
        createdAt: formatDate(createdAt),
        updatedAt: formatDate(updatedAt),
        ticker: corporate?.ticker,
        exchange: corporate?.exchange,
        isin: corporate?.isin,
        marketCap: corporate?.marketCap?.toString(),
        marketCapCurrency: corporate?.marketCapCurrency,
        sector: corporate?.sector,
        industry: corporate?.industry,
        fiscalYearEnd: corporate?.fiscalYearEnd,
        irWebsite: corporate?.irWebsite,
        activeStatus: activeStatus,
    };

    return (
        <tr className='oe-data-organizations-list-item'>
            {visibleColumnIds.map(columnId => (
                <Text key={columnId} tag='td' className='hoverable' message={columnValues[columnId] || ''} withEllipsis escapeHtml={true} />
            ))}
            <td className='hoverable' style={{ width: 72 }} />
        </tr>
    );
};

export { OeDataOrganizationsListItem };
